import React, { useState } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHotel,
  faUtensils,
  faMugHot,
  faTruck,
  faUsers,
  faConciergeBell,
  faBed,
  faBowlFood,
  faHandshake,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";
import HorecaHubMetaverseStakeholderModal from "./HorecaHubMetaverseStakeholderModal";

const stakeholders = [
  { icon: faHotel, label: "Hotels", info: "Manage rooms, reservations & guest services." },
  { icon: faUtensils, label: "Restaurants", info: "Menu design, dining operations & customer experience." },
  { icon: faMugHot, label: "Cafes & Bars", info: "Beverage service, quick bites & ambiance management." },
  { icon: faTruck, label: "Suppliers", info: "Fresh ingredients, timely delivery & quality assurance." },
  { icon: faUsers, label: "Guests", info: "Feedback, loyalty programs & personalized experiences." },
  { icon: faConciergeBell, label: "Front Desk", info: "Check-ins, concierge & guest relations." },
  { icon: faBed, label: "Housekeeping", info: "Room cleanliness, linen management & standards." },
  { icon: faBowlFood, label: "Kitchen & Chefs", info: "Recipe execution, food safety & creative plating." },
  { icon: faHandshake, label: "Partners & Vendors", info: "Collaborations, contracts & service integrations." },
  { icon: faShoppingCart, label: "Procurement", info: "Inventory ordering, cost control & vendor management." },
];

const HorecaHubMetaverseStakeholdersGrid = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="py-12">
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 w-full max-w-6xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, staggerChildren: 0.1 }}
      >
        {stakeholders.map((s, i) => (
          <motion.div
            key={i}
            className="bg-white p-6 rounded-3xl shadow-lg flex flex-col items-center cursor-pointer hover:shadow-2xl transition-all duration-300 border border-amber-100"
            whileHover={{ scale: 1.1, y: -8 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => setSelected(s)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
          >
            <div className="bg-amber-100 rounded-full p-6 mb-4">
              <FontAwesomeIcon icon={s.icon} className="text-amber-700 text-4xl" />
            </div>
            <span className="font-semibold text-lg text-amber-900 text-center">{s.label}</span>
            <span className="text-sm text-amber-600 mt-2 text-center opacity-80">{s.info}</span>
          </motion.div>
        ))}
      </motion.div>

      {selected && (
        <HorecaHubMetaverseStakeholderModal stakeholder={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
};

export default HorecaHubMetaverseStakeholdersGrid;